import Fetch, { FRONT_URL } from "../../../fetch";

export const sendMail = async ({ email }) => {
  const link = `${FRONT_URL}reset/`;
  return await Fetch({
    route: "password-resets",
    method: "POST",
    body: JSON.stringify({ email, link })
  });
};

export const validLink = async token => {
  return await Fetch({
    route: "password-resets/" + token,
    method: "GET"
  });
};

export const submit = async ({ token, password }) => {
  return await Fetch({
    route: "password-resets/" + token,
    method: "PUT",
    body: JSON.stringify({ password })
  });
};
